import moment from 'moment';
import { NORMALIZED_ENTIRE_PATTERN } from '@/utils/date';
import { removeHTMLTagsFromText } from '@/utils/formatter';
import { getChannelObj } from '@/utils/channels';

const formatterTextToChart = (text) => {
  const maximumTextSize = 160;
  let strippedHTMLTagsText = removeHTMLTagsFromText(text);
  const isBiggerThanMaximumTextSize = strippedHTMLTagsText.length > maximumTextSize;

  if (isBiggerThanMaximumTextSize) {
    strippedHTMLTagsText = strippedHTMLTagsText.substr(0, maximumTextSize);
  }

  return strippedHTMLTagsText.replace(/(.{35})/ug, '$1<br>');
};

const getChannelIndex = (array, channelName) => {
  return array.findIndex(({ channel }) => channel === channelName);
};

const getIconToTooltip = ({ icon }) => {
  try {
    return require(`../../../assets/img/social/${icon}.png`);
  } catch {}

  return '';
};

const formatterDateToChart = (dateISO) => {
  return moment(dateISO, 'x').format(NORMALIZED_ENTIRE_PATTERN);
};

const createBubbleToMatrixTags = ({
  impressions,
  name: tagName,
  engagement_rate: engagementRate,
  net_sentiment: netSentiment,
}) => ({
  tagName,
  x: netSentiment,
  y: engagementRate,
  z: impressions,
});

export default {
  tags: {
    servicePath: 'engagementMatrixTags',
    series: ({ tags }) => {
      return tags?.map(tag => {
        const tagName = tag.name;
        const bubble = createBubbleToMatrixTags(tag);

        return {
          name: tagName,
          data: [bubble],
        };
      });
    },
    getTooltipHTML: (tag) => {
      return `
        <span>
          <span style="
            display: block;
            margin-top: 8px;
            min-width: 200px;"
          >
            ${tag.tagName}
          </span>
          <span style="
            display: block;
            margin-top: 16px;"
          >
            Taxa de engajamento (média): <b>${tag.y.toFixed(3)}</b>
          </span>
          <span style="
            display: block;
            margin-top: 8px;"
          >
            Taxa de sentimento (média): <b>${tag.x.toFixed(1)}</b>
          </span>
          <span style="
            display: block;
            margin-top: 8px;"
          >
            Impressões (média): <b>${tag.z.toFixed(1)}</b>
          </span>
        </span>
      `;
    },
  },
  posts: {
    servicePath: 'engagementMatrixPosts',
    series: (data) => {
      const series = [];

      data.posts?.forEach(post => {
        const channelName = post.channel.toLowerCase();
        const channelObj = getChannelObj(channelName);

        const icon = getIconToTooltip(channelObj);
        const text = formatterTextToChart(post.text);
        const postedAt = formatterDateToChart(post.posted_at);

        const channelIndex = getChannelIndex(series, channelName);
        const bubble = {
          icon,
          text,
          postedAt,
          postImg: post.post_img,
          postUrl: post.post_url,
          x: post.net_sentiment,
          y: post.engagement_rate,
          z: post.impressions,
        };

        if (channelIndex < 0) {
          series.push({
            channel: channelName,
            color: channelObj.color,
            name: channelObj.name,
            data: [bubble],
          });
        } else {
          series[channelIndex].data.push(bubble);
        }
      });

      return series;
    },
    getTooltipHTML: (point) => {
      const imageHTML = point.postImg
        ? `<span style="
            display: flex;
            align-items: center;
            margin-top: 8px;"
          >
            <span style="
              width: 100%;
              height: 150px;
              background-image: url('${point.postImg}');
              background-size: cover;
              background-position: top center;
              background-repeat: no-repeat;"
            ></span>
          </span>`
        : '';

      return `
        <span>
          <a href="${point.postUrl}" target="_blank" style="color: inherit;">
            <span style="
              display: flex;
              justify-content: space-between;
              align-items: center;"
            >
              <span style="
                background-image: url('${point.icon}');
                background-size: contain;
                background-position: center center;
                background-repeat: no-repeat;
                width: 25px;
                height: 25px;"
              ></span>
              <span>${point.postedAt}</span>
            </span>
            ${imageHTML}
            <span style="
              display: block;
              margin-top: 8px;
              min-width: 200px;"
            >
              ${point.text}
            </span>
            <span style="
              display: block;
              margin-top: 16px;"
            >
              Taxa de engajamento: <b>${point.y.toFixed(3)}</b>
            </span>
            <span style="
              display: block;
              margin-top: 8px;"
            >
              Taxa de sentimento: <b>${point.x.toFixed(1)}</b>
            </span>
            <span style="
              display: block;
              margin-top: 8px;"
            >
              Impressões: <b>${point.z}</b>
            </span>
          </a>
        </span>
      `;
    },
  },
};
